import React, { Component } from 'react';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBlock,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';
import BankDetails from './BankDetails';
import Employed from './Employed';
import Business from './Business';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

import Loader from 'react-loaders';
import { loadProgressBar } from 'axios-progress-bar';
loadProgressBar()
class LoanForm extends Component {

  constructor(props) {
    super(props);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleUserInputotp = this.handleUserInputotp.bind(this);
    this.companyclick = this.companyclick.bind(this);
    this.hide_company_list = this.hide_company_list.bind(this);
    this.showcompanylist = this.showcompanylist.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.initializeState = this.initializeState.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
    this.toggleotpModal = this.toggleotpModal.bind(this);
    this.sendOTP = this.sendOTP.bind(this);
    this.ResendOTP = this.ResendOTP.bind(this);
    this.submitOtp = this.submitOtp.bind(this);

    this.state = {
      productTypes: [],
      isActiveButton: false,
      showBankDetails: false,
      salaryMode: [],
      cities: [],
      highest_education: [],
      ownership_type: [],
      states: [],
      professions: [],
      designations: [],
      educations: [],
      employment_types: [],
      selectedProduct: '',
      firstName: '',
      lastName: '',
      gender: '',
      email: '',
      office_email: '',
      mobile: '',
      panNumber: '',
      aadhaar: '',
      incomeMode: 'salaried',
      salary: '',
      salaryModeSelect: 1,
      profession: '',
      residenceType: '',
      resAddress: '',
      selectCity: 147,
      selectOwnership: '',
      selectOfficeCity: '',
      office_city: [],
      office_pin: '',
      otp: '',
      otp_sent: false,
      otp_unable_to_send: false,
      pinCode: '',
      comment: '',
      bankLoanAmount: '',
      bankLoanRate: '',
      bankRefId: '',
      bankLoanDisbursalDate: '',
      companyName: '',
      companies: [],
      companyclick: '',
      emailValid: '',
      aadhaarValid: '',
      designation: '',
      experience: '',
      designationOther: '',
      otherProfession: '',
      workStartYear: '',
      serverError: '',
      loan_roi: 4,
      loan_amount: 0,
      loan_tenure: 0,
      lastNameValid: '',
      mobileValid: '',
      panNumberValid: '',
      ofcPhone: '',
      dateOfBirth: '',
      bank_loan_amount: '',
      bank_loan_rate: '',
      loaderActive: false,
      occupied_since: '',
      office_address: '',
      serverMsg: '',
      showcompanyfilter: false,
      timeouterror: '',
      ovd_docs: [
        { id: "1", name: "Aadhaar Card" },
        { id: "2", name: "Driving Licence" },
        { id: "3", name: "Passport" },
        { id: "4", name: "Voter ID" },
      ],
      selectOVD: '0',
      dlValid: 'is-invalid',
      voterIDValid: 'is-invalid',
      passportValid: 'is-invalid',
      passport: '',
      voterIDNumber: '',
      ovd_val: ''
    };
  }

  componentDidMount() {
    this.getApplicationFormData();
  }

  initializeState() {
    this.setState(prevState => ({
      showBankDetails: false,
      selectedProduct: '',
      selectedProductValid: '',
      firstName: '',
      lastName: '',
      gender: '',
      email: '',
      office_email: '',
      mobile: '',
      panNumber: '',
      aadhaar: '',
      incomeMode: 'salaried',
      salary: '',
      salaryModeSelect: 1,
      profession: '',
      residenceType: '',
      resAddress: '',
      highest_education: [],
      selectCity: 147,
      selectOwnership: '',
      selectOfficeCity: '',
      office_city: [],
      office_pin: '',
      office_pinValid: '',
      pinCode: '',
      comment: '',
      bankLoanAmount: '',
      bankLoanRate: '',
      bankRefId: '',
      bankLoanDisbursalDate: '',
      companyName: '',
      companies: [],
      companyclick: '',
      emailValid: '',
      occupiedSinceValid: '',
      designation: '',
      experience: '',
      designationOther: '',
      otherProfession: '',
      workStartYear: '',
      serverError: '',
      loan_roi: 4,
      loan_amount: 0,
      loan_tenure: 0,
      firstNameValid: '',
      lastNameValid: '',
      mobileValid: '',
      panNumberValid: '',
      ofcPhone: '',
      dateOfBirth: '',
      bank_loan_amount: '',
      bank_loan_rate: '',
      loanAmountValid: '',
      bankRateValid: '',
      office_address: '',
      occupied_since: '',
      selectOVD: '0'
    }));
  }

  getApplicationFormData() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.GET_APP_FORM_DATA_MODE
    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          self.setState(prevState => ({
            productTypes: response.data.products,
            salaryMode: response.data.salary_modes,
            cities: response.data.cities,
            ownership_type: response.data.ownership_type,
            states: response.data.states,
            professions: response.data.professions,
            designations: response.data.designations,
            highest_education: response.data.highest_education,
            // educations: response.data.educations,
            employment_types: response.data.employment_types,
          }));
        } else {
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
      });
  }

  companyclick(e) {
    var companyname = e.target.textContent;
    this.setState({ companyName: companyname, showcompanyfilter: false });
  }

  addcompanies() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.COMPANIES,
      key: this.state.companyName,
    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          self.setState(prevState => ({
            companies: response.data
          }));
        } else {
          self.setState(prevState => ({
          }));
        }
      })
      .catch(function (error) {
        self.setState(prevState => ({
        }));
      });
  }

  handleUserInputotp(e) {
    const value = e.target.value;
    this.setState({ otp: value });
  }
  
  handleUserInput(e) {
    const name = e.target.name;
    var value = e.target.value;
    this.setState({ [name]: value },
      () => { this.validateField(name, value) });

    if (name == "companyName") {
      this.showcompanylist();

    }
  }

  hide_company_list() {
    this.setState({ companies: [], showcompanyfilter: false });
  }

  showcompanylist(e) {
    if (this.state.companyName.length < 3) {

    } else {
      this.setState({ companies: [], showcompanyfilter: true });
      this.addcompanies();
    }
  }


  handleAmountSlider(e) {
    const value = e;
    this.setState({ loan_amount: value });
  }

  handleROISlider(e) {
    const value = e;
    this.setState({ loan_roi: value });
  }

  handleTenureSlider(e) {
    const value = e;
    this.setState({ loan_tenure: value });
  }

  validateField(fieldName, value) {
    switch (fieldName) {
      case 'email':
        if (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
          this.setState({
            emailValid: 'is-valid'
          })
        } else {
          this.setState({
            emailValid: 'is-invalid',
          })
        }
      case 'occupied_since':
        if (value.match(/^\d{4}$/)) {
          this.setState({
            occupiedSinceValid: 'is-valid'
          })
        } else {
          this.setState({
            occupiedSinceValid: 'is-invalid',
          })
        }
        break;
      case 'firstName':
        if (value.match(/^[A-Za-z\s]+$/)) {
          this.setState({
            firstNameValid: 'is-valid',
          });
        } else {
          this.setState({
            firstNameValid: 'is-invalid'
          });
        }
        break;
      case 'lastName':
        if (value.match(/^[A-Za-z\s]+$/)) {
          this.setState({
            lastNameValid: 'is-valid',
          });
        } else {
          this.setState({
            lastNameValid: 'is-invalid'
          });
        }
        break;
      case 'mobile':
        if (/^\d{10}$/.test(value)) {
          this.setState({
            mobileValid: 'is-valid'
          })
        } else {
          this.setState({
            mobileValid: 'is-invalid',
          })
        }
        break;
      case 'panNumber':
        if (/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(value)) {
          this.setState({
            panValid: 'is-valid'
          });
        } else {
          this.setState({
            panValid: 'is-invalid',
          });
        }
        break;
      case 'selectedProduct':
        if (value === '') {
          this.setState({
            selectedProductValid: 'is-invalid',
          });
        } else {
          this.setState({
            selectedProductValid: 'is-valid'
          });
        }
        break;
      case 'resAddress':
        if (value === '') {
          this.setState({
            resValid: 'is-invalid',
          })
        } else {
          this.setState({
            resValid: 'is-valid'
          });
        }
        break;
      case 'pinCode':
        if (value === '') {
          this.setState({
            pinValid: 'is-invalid',
          });
        } else if (value.length != 6) {
          this.setState({
            pinValid: 'is-invalid',
          });
        } else {
          this.setState({
            pinValid: 'is-valid'
          });
        }
        break;
      case 'aadhaar':
        if (/^\d{12}$/.test(value)) {
          this.setState({
            aadhaarValid: 'is-valid'
          });
        } else {
          this.setState({
            aadhaarValid: 'is-invalid',
          });
        }
        break;
      case 'salary':
        if (/^[0-9]+$/.test(value)) {
          this.setState({
            salaryValid: 'is-valid',
          })
        } else {
          this.setState({
            salaryValid: 'is-invalid'
          })
        }
        break;

      case 'dl':
        if (/^[A-Z]{2}[0-9]{13}$/.test(value)) {
          this.setState({ dlValid: "isvalid" });
        }
        else {
          this.setState({
            dlValid: 'is-invalid'
          });

        }
        break;

      case 'passport':
        if (/^[A-Z]{1}[0-9]{7}$/.test(value)) {
          this.setState({ passportValid: "isvalid" });
        }
        else {
          this.setState({
            passportValid: 'is-invalid'
          });

        }
        break;

      case 'voterIDNumber':
        if (/^[A-Z]{3}[0-9]{7}$/.test(value)) {
          this.setState({
            voterIDValid: "is-valid"
          });
        }
        else {
          this.setState({
            voterIDValid: 'is-invalid'
          });
        }
        break;

      default:
        break;
    }
  }

  submitForm(e) {
    var ovd_value = ''

    this.toggleLoader();
    //handle mandatory fields
    if (this.state.firstNameValid === 'is-invalid' ||
      this.state.selectedProductValid === 'is-invalid' ||
      this.state.lastNameValid === 'is-invalid' ||
      this.state.emailValid === 'is-invalid' ||
      this.state.mobileValid === 'is-invalid' ||
      this.state.aadhaarValid == 'is-invalid' ||
      this.state.panNumberValid === 'is-invalid' ||
      this.state.salaryValid === 'is-invalid' ||
      this.state.resAddressValid === 'is-invalid' ||
      this.state.selectCity === '' ||
      this.state.pinCodeValid === 'is-invalid' ||
      this.state.dateOfBirth === '' ||
      this.state.selectOVD == '0' ||
      (this.state.selectOVD == '1' && this.state.aadhaarValid == "is-invalid") ||
      (this.state.selectOVD == '2' && this.state.dlValid == "is-invalid") ||
      (this.state.selectOVD == '3' && this.state.passportValid == "is-invalid") ||
      (this.state.selectOVD == '4' && this.state.voterIDValid == "is-invalid")) {
      this.setState({
        serverError: 'Please ensure that you have entered all the mandatory fields correctly',
        loaderActive: false,
      });
    } else {
      this.toggleLoader();
      this.setState({
        serverError: ''
      });

      if (this.state.selectOVD == '1') {
        ovd_value = this.state.aadhaar
      }
      else if (this.state.selectOVD == '2') {
        ovd_value = this.state.dl

      }
      else if (this.state.selectOVD == '3') {
        ovd_value = this.state.passport

      }
      else if (this.state.selectOVD == '4') {
        ovd_value = this.state.voterIDNumber

      }
      else{

        alert("No OVD Document selected");
      }
     
     this.createLead(ovd_value);
      
    }
  }

  submitOtp() {console.log('remove otp functionality');}
  // submitOtp() {

  //   var self = this;
  //   self.toggleLoader();
  //   var querystring = require('querystring');
  //   var payload = querystring.stringify({
  //     mode: Constant.SUBMIT_OTP,
  //     lead_id: self.state.lead_id,
  //     otp: self.state.otp,
  //   });
  //   axios({
  //     method: 'post',
  //     url: Constant.API_URL,
  //     headers: {
  //       'content-type': 'application/x-www-form-urlencoded',
  //       'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
  //       'token': window.localStorage.getItem(Constant.TOKEN)
  //     },
  //     withCredentials: false,
  //     data: payload
  //   })
  //     .then(function (response) {
  //       self.toggleLoader();
  //       if (response.status == 200) {
  //         self.setState(prevState => ({
  //           otp_sent: true
  //         }));
  //         alert("OTP Verified");
  //         self.navigateToLoanDetails();
        
  //       } else {
  //         self.setState(prevState => ({
  //           otp_unable_to_send: true,
  //           errorMsg: response.data.error
  //         }));
  //       }
  //     })
  //     .catch(function (error) {
  //       self.setState(prevState => ({
  //         otp_unable_to_send: true,
  //         errorMsg: "Server error"
  //       }));
  //     });
  // }

  ResendOTP() {console.log('remove otp functionality');}
  // ResendOTP() {
  //   this.setState({
  //     isActiveButton: false

  //   }, function () {
  //   });
  //   var self = this;
  //   self.toggleLoader();
  //   var querystring = require('querystring');
  //   var payload = querystring.stringify({
  //     mode: Constant.SEND_OTP,
  //     lead_id: self.state.lead_id,
  //   })
  //   axios({
  //     method: 'post',
  //     url: Constant.API_URL,
  //     headers: {
  //       'content-type': 'application/x-www-form-urlencoded',
  //       'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
  //       'token': window.localStorage.getItem(Constant.TOKEN)
  //     },
  //     withCredentials: false,
  //     data: payload
  //   })
  //     .then(function (response) {
  //       self.toggleLoader();
  //       if (response.status == 200) {
  //         // console.log(response);
  //         self.setState(prevState => ({
  //           otp_sent: true
  //         }));
  //       } else {
  //         // console.log(response);
  //         self.setState(prevState => ({
  //           otp_unable_to_send: true,
  //           errorMsg: response.data.error
  //         }));
  //       }
  //     })
  //     .catch(function (error) {
  //       // console.log("Error");
  //       // console.log(error);
  //       self.setState(prevState => ({
  //         otp_unable_to_send: true,
  //         errorMsg: "Server error"
  //       }));
  //     });
  // }

  sendOTP() {console.log('remove otp functionality');}
  // sendOTP() {
  //   this.setState({
  //     isActiveButton: true
  //   });
  //   var self = this;
  //   self.toggleLoader();
  //   var querystring = require('querystring');
  //   var payload = querystring.stringify({
  //     mode: Constant.SEND_OTP,
  //     lead_id: self.state.lead_id,
  //   })
  //   axios({
  //     method: 'post',
  //     url: Constant.API_URL,
  //     headers: {
  //       'content-type': 'application/x-www-form-urlencoded',
  //       'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
  //       'token': window.localStorage.getItem(Constant.TOKEN)
  //     },
  //     withCredentials: false,
  //     data: payload
  //   })
  //     .then(function (response) {
  //       self.toggleLoader();
  //       if (response.status == 200) {
  //         // console.log(response);
  //         self.setState(prevState => ({
  //           otp_sent: true
  //         }));
  //       } else {
  //         // console.log(response);
  //         self.setState(prevState => ({
  //           otp_unable_to_send: true,
  //           errorMsg: response.data.error
  //         }));
  //       }
  //     })
  //     .catch(function (error) {
  //       // console.log("Error");
  //       // console.log(error);
  //       self.setState(prevState => ({
  //         otp_unable_to_send: true,
  //         errorMsg: "Server error"
  //       }));
  //     });
  // }

  createLead(ovd_value) {

    var self = this;

    self.setState({
      serverMsg: "",
      serverError: ""
    })


    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.CREATE_LEAD,
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      mobile: this.state.mobile,
      email: this.state.email,
      office_email: this.state.office_email,
      pan_number: this.state.panNumber,
      gender: this.state.gender,
      // aadhar_number: this.state.aadhaar,
      company: this.state.companyName,
      employment_type: this.state.incomeMode,
      salary: this.state.salary,
      salary_mode: this.state.salaryModeSelect,
      ownership_type: this.state.selectOwnership,
      city: this.state.selectCity,
      office_city: this.state.selectOfficeCity,
      address_line_1: this.state.resAddress,
      address_line_2: this.state.resAddress2,
      pin: this.state.pinCode,
      product_type: this.state.selectedProduct,
      loan_amount: this.state.loan_amount,
      loan_tenure: this.state.loan_tenure,
      loan_roi: this.state.loan_roi,
      bank_id: this.state.bank_id,
      bank_loan_amount: this.state.bank_loan_amount,
      bank_loan_rate: this.state.bank_loan_rate,
      bank_loan_tenure: this.state.bank_loan_tenure,
      bank_loan_ref_id: this.state.bank_loan_ref_id,
      profession: this.state.profession,
      work_start_year: this.state.workStartYear,
      designation_id: this.state.designation,
      experience: this.state.experience,
      office_phone: this.state.ofcPhone,
      dateOfBirth: this.state.dateOfBirth,
      office_address: this.state.office_address,
      occupied_since: this.state.occupied_since,
      office_pin: this.state.office_pin,
      bank_name: this.state.bank_id,
      highest_education: this.state.highestEducation,
      ovd_id: this.state.selectOVD,
      ovd_number: ovd_value

    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload,
      timeout: 30000

    })
      .then(function (response) {
        self.toggleLoader();
        if (response.status == 200) {
          // console.log(response);
          self.setState(prevState => ({
            lead_id: response.data.lead_id,
            serverMsg: response.data.msg
          }));
          // self.toggleotpModal();
            self.navigateToLoanDetails();
        } else {
          self.setState(prevState => ({
            serverError: response.data.error
          }));
        }
      })
      .catch(function (error) {
        self.toggleLoader();
        self.setState(prevState => ({
          serverError: error
        }));
        if (error.code == 'ECONNABORTED') {
          self.setState({ timeouterror: 'Request timed out. Please try again after sometime' })
        }

        // console.log(error);
      });
  }

  toggleotpModal() {
    this.setState({
      otpModal: !this.state.otpModal,
      otp_sent: false,
      otp_unable_to_send: false,
    })

  }

  toggleLoader() {
    console.log("Setting state: " + this.state.loaderActive);
    this.setState({
      loaderActive: !this.state.loaderActive,
    })
  }

  // navigateToDashboard() {
  //   this.props.history.push('/dashboard');
  // }

  navigateToLoanDetails() {
    this.props.history.push('/loanDetails/'+this.state.lead_id );
  }


  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader className='header-t2'>
            <strong>Create New Lead</strong>
          </CardHeader>
          <CardBlock className="card-body">
            <div className="mandatory">
              <h6>Fields marked with an asterisk(*) are mandatory.</h6>
            </div>
            <div className="fields" style={{ padding: '0px 15px 0px 15px' }}>
              <Form action='' className="form-horizontal">
                <div className="row1">
                  <FormGroup row>
                    <Col xs="12" md="1">
                      <Label htmlFor="select">Product Type*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="select" name="selectedProduct" id="select" className={this.state.selectedProductValid} onChange={(event) => this.handleUserInput(event)}>
                        <option value="0">Please select</option>
                        {this.state.productTypes.map((data, key) =>
                          <option key={key} value={data.product_code}>{data.product_name}</option>
                        )}
                      </Input>
                    </Col>
                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">First Name*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="text" id="text-input" name="firstName" placeholder="" className={this.state.firstNameValid} value={this.state.firstName} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />

                    </Col>
                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">Last Name*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="text" id="text-input" name="lastName" placeholder="" className={this.state.lastNameValid} value={this.state.lastName} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                    </Col>

                  </FormGroup>


                  <FormGroup row>
                    <Col xs="12" md="1">
                      <Label htmlFor="select">Gender*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Label><Input className="radio-btn" type="radio" name="gender" value="male"
                        onChange={(event) => this.handleUserInput(event)} /> Male</Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Label><Input className="radio-btn" type="radio" name="gender" value="female"
                        onChange={(event) => this.handleUserInput(event)} /> Female</Label>
                    </Col>
                    <Col xs="12" md="1">
                      <Label htmlFor="contact-input" className="tag-text">Mobile No.*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="number" id="contact-input" name="mobile" placeholder="" className={this.state.mobileValid} value={this.state.mobile} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                      <FormText color="muted">Please enter valid number, OTP will be sent on this number for verification
                            </FormText>
                    </Col>
                    <Col xs="12" md="1">
                      <Label htmlFor="email-input">Email*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="email" id="email-input" name="email" placeholder="" className={this.state.emailValid} value={this.state.email} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                      <FormText color="muted">Please enter valid email, verification link will be sent on this address
                            </FormText>
                    </Col>
                  </FormGroup>
                  <FormGroup row>

                    <Col xs="12" md="1">
                      <Label htmlFor="select">Date of Birth*</Label>
                    </Col>

                    <Col xs="12" md="3">
                      <Input type="date" name="dateOfBirth" id="select" value={this.state.dateOfBirth} onChange={(event) => this.handleUserInput(event)}></Input>
                    </Col>

                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">Highest Education</Label>
                    </Col>

                    <Col xs="12" md="3">

                      <Input type="select" name="highestEducation" value={this.state.highestEducation} id="select" onChange={(event) => this.handleUserInput(event)}>

                        <option value="0">Please select</option>

                        {this.state.highest_education.map((data, key) =>
                          <option key={key} value={data.id}>{data.education}</option>
                        )}

                      </Input>
                    </Col>

                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">Residential Address*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="text" name="resAddress" placeholder="Address Line 1" className={this.state.resValid} value={this.state.resAddress} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                      <Input type="text" name="resAddress2" placeholder="Address Line 2 (Optional)" className={this.state.resValid2} value={this.state.resAddress2} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                    </Col>
                  </FormGroup>
                  <FormGroup row>

                    <Col xs="12" md="1">
                      <Label htmlFor="select">City*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="select" name="selectCity" value={this.state.selectCity} id="select" onChange={(event) => this.handleUserInput(event)}>
                        <option value="0">Please select</option>
                        {this.state.cities.map((data, key) =>
                          <option key={key} value={data.city_id}>{data.city_name} ({data.state_name})</option>
                        )}
                      </Input>
                    </Col>

                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">PIN Code*</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="number" id="text-input" name="pinCode" placeholder="" className={this.state.pinValid} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                    </Col>

                    <Col xs="12" md="1">
                      <Label htmlFor="select">Ownership type</Label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="select" name="selectOwnership" value={this.state.selectOwnership} id="select" onChange={(event) => this.handleUserInput(event)}>
                        <option value="0">Please select</option>
                        {this.state.ownership_type.map((data, key) =>
                          <option key={key} value={data.id}>{data.ownership_type}</option>
                        )}
                      </Input>
                    </Col>

                  </FormGroup>
                  <FormGroup row>

                    <Col xs="12" md="1">
                      <Label htmlFor="select">Occupied Since</Label>
                    </Col>

                    <Col xs="12" md="3">
                      <Input type="number" name="occupied_since" id="select" className={this.state.occupiedSinceValid} placeholder="YYYY" value={this.state.occupied_since} min="1900" maxLength="4" pattern="[0-9]{4}" onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                      }} min={0} onChange={(event) => this.handleUserInput(event)}></Input>
                    </Col>

                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">OVD Document*</Label>
                    </Col>

                    <Col xs="12" md="3">
                      <Input type="select" name="selectOVD" value={this.state.selectOVD} id="select" onChange={(event) => this.handleUserInput(event)}>
                        <option value="0">Please select an OVD Document</option>
                        {this.state.ovd_docs.map((data, key) =>
                          <option key={key} value={data.id}>{data.name}</option>

                        )}
                      </Input>
                    </Col>
                    {this.state.selectOVD == "2" ?
                      [<Col xs="1" md="1">
                        <Label htmlFor="text-input">Driving Licence Number*</Label>
                      </Col>,

                      <Col xs="3" md="3">
                        <Input type="text" id="text-input" name="dl" className={this.state.dlValid} placeholder="" value={this.state.dl} maxLength="16" onChange={(event) => this.handleUserInput(event)} onInput={(e) => {
                          e.target.value = (e.target.value).toString().slice(0, 15).toUpperCase()
                        }} onBlur={(event) => this.handleUserInput(event)} />
                      </Col>]
                      :
                      this.state.selectOVD == "3" ?
                        [<Col xs="1" md="1">
                          <Label htmlFor="text-input">Passport Number*</Label>
                        </Col>,

                        <Col xs="3" md="3">
                          <Input type="text" id="text-input" className={this.state.passportValid} name="passport" placeholder="" value={this.state.passport} maxLength="8" onChange={(event) => this.handleUserInput(event)}
                            onInput={(e) => {
                              e.target.value = (e.target.value).toString().slice(0, 12).toUpperCase()
                            }} onBlur={(event) => this.handleUserInput(event)} />
                        </Col>]
                        :
                        this.state.selectOVD == "4" ?
                          [<Col xs="1" md="1">
                            <Label htmlFor="text-input">Voter ID Number*</Label>
                          </Col>,

                          <Col xs="3" md="3">
                            <Input type="text" id="text-input" className={this.state.voterIDValid} name="voterIDNumber" placeholder="" value={this.state.voterIDNumber} maxLength="12" onChange={(event) => this.handleUserInput(event)}
                              onInput={(e) => {
                                e.target.value = (e.target.value).toString().slice(0, 10).toUpperCase()
                              }} onBlur={(event) => this.handleUserInput(event)} />
                          </Col>]
                          :
                          this.state.selectOVD == "1" ?
                            [<Col xs="1" md="1">
                              <Label htmlFor="text-input">Aadhaar Number*</Label>
                            </Col>,

                            <Col xs="12" md="3">
                              <Input type="number" id="text-input" name="aadhaar" className={this.state.aadhaarValid} placeholder="" value={this.state.aadhaar} maxLength="12" onChange={(event) => this.handleUserInput(event)} onInput={(e) => {
                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                              }} min={0} onBlur={(event) => this.handleUserInput(event)} />
                            </Col>]
                            :

                            ""
                    }

                    {/* <Col xs="12" md="3">
                      <Input type="number" id="text-input" name="aadhaar" placeholder="" value={this.state.aadhaar} maxLength="12" onChange={(event) => this.handleUserInput(event)} onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                      }} min={0} onBlur={(event) => this.handleUserInput(event)} />
                    </Col> */}

                  </FormGroup>
                  <FormGroup row>

                    <Col xs="12" md="1">
                      <Label htmlFor="text-input">PAN Number*</Label>
                    </Col>

                    <Col xs="12" md="3">
                      <Input type="text" id="text-input" name="panNumber" placeholder="" className={this.state.panValid} value={this.state.panNumber}
                        onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)}
                        onInput={(e) => {
                          e.target.value = (e.target.value).toString().slice(0, 10).toUpperCase()
                        }} />
                    </Col>

                    <Col xs="6" md="1">
                      <Label htmlFor="select">Employment type*</Label>
                    </Col>

                    <Col xs="12" md="3">
                      <Input type="select" name="incomeMode" id="select" value={this.state.incomeMode} onChange={(event) => this.handleUserInput(event)}> {this.state.employment_types.map((data, key) =>
                        <option key={key} value={data.value}>{data.type}</option>
                      )}
                      </Input>
                    </Col>
                    <Col xs="12" md="1">
                      <label htmlFor="select">Office City</label>
                    </Col>
                    <Col xs="12" md="3">
                      <Input type="select" name="selectOfficeCity" value={this.state.selectOfficeCity} id="select" onChange={(event) => this.handleUserInput(event)}>
                        <option value="0">Please select</option>
                        {this.state.cities.map((data, key) =>
                          <option key={key} value={data.city_id}>{data.city_name}</option>
                        )}
                      </Input>
                    </Col>
                  </FormGroup>
                  {this.state.incomeMode === "salaried" ?
                    <Employed salaryMode={this.state.salaryMode} salary={this.state.salary} salaryModeSelect={this.state.salaryModeSelect} companyName={this.state.companyName} companies={this.state.companies} companyclick={this.companyclick} hide_company_list={this.hide_company_list}
                      workStartYear={this.state.workStartYear} profession={this.state.profession} office_email={this.state.office_email} designation={this.state.designation} experience={this.state.experience} handleUserInput={this.handleUserInput} showcompanylist={this.showcompanylist} showcompanyfilter={this.state.showcompanyfilter}
                      salaryValid={this.state.salaryValid} designationOther={this.state.designationOther} otherProfession={this.state.otherProfession} professions={this.state.professions} designations={this.state.designations} /> : this.state.incomeMode === "self employed" ?
                      
                      <Business salary={this.state.salary} companyName={this.state.companyName} companies={this.state.companies} companyclick={this.companyclick} showcompanyfilter={this.state.showcompanyfilter} hide_company_list={this.hide_company_list} handleUserInput={this.handleUserInput}
                        showcompanylist={this.showcompanylist} salaryValid={this.state.salaryValid} /> :

                      <Col md="4"></Col>
                  }
                </div>
              </Form>
            </div>
            <FormGroup row>
              <FormText color="danger" id="danger">{this.state.serverError}</FormText>
              <FormText color="success" id="danger">{this.state.serverMsg}</FormText>
            </FormGroup>
          </CardBlock>
          <CardFooter className="footer-t2">
            <div style={{ color: 'red' }}>{this.state.timeouterror ? this.state.timeouterror : ''}</div>

            <Button type="submit" size="lg" color="primary" onClick={this.submitForm}><i
              className="fa fa-dot-circle-o"></i> Submit</Button>
            <Button type="reset" size="lg" color="danger" onClick={this.initializeState}><i
              className="fa fa-ban"></i> Reset</Button>
          </CardFooter>
        </Card>

        <Modal isOpen={this.state.otpModal} toggle={this.toggleotpModal} className={this.props.className}>
          <ModalHeader toggle={this.toggleotpModal}>OTP Verification </ModalHeader>
          <ModalBody>
            <FormGroup>
              {this.state.otp_sent ?
                <FormText color="success">OTP sent successfully</FormText> :
                <div></div>} {this.state.otp_unable_to_send ?
                  <FormText color="danger">{this.state.errorMsg}</FormText> :
                  <div></div>}

              <Label>Enter OTP</Label> <input type="number" name="otp" value={this.state.otp} onChange={(event) => this.handleUserInputotp(event)} /><br />
              <Button color="primary" onClick={this.submitOtp}>Submit</Button>

            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {this.state.isActiveButton == false ?
              <Button color="primary" onClick={this.sendOTP}>Send OTP</Button> :
              <Button color="primary" onClick={this.ResendOTP}>Resend OTP</Button>}

          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.loaderActive} toggle={this.toggleLoader} className="loader-modal" backdrop={"static"}>
          <Loader type="ball-pulse" active />
        </Modal>
      </div>
    )
  }
}

export default LoanForm;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanForm/LoanForm.js